import React, { useEffect, useRef, useState } from 'react';
import { apiCall } from '../helpers/MainHelper';

export default function ReportFilterLookup({ id, label, type, query, selected, customerId, onQueryChange, onSelect }) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [active, setActive] = useState(-1);
  const [upward, setUpward] = useState(false);
  const root = useRef(null);
  const input = useRef(null);

  useEffect(() => {
    const outside = event => { if (root.current && !root.current.contains(event.target)) setOpen(false); };
    document.addEventListener('mousedown', outside);
    return () => document.removeEventListener('mousedown', outside);
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    let canceled = false;
    setOptions([]);
    setActive(-1);
    setError('');
    if (!open || query.trim().length < 2 || (selected && query === selected.label)) {
      setLoading(false);
      return () => controller.abort();
    }
    setLoading(true);
    const timer = setTimeout(async () => {
      try {
        const params = new URLSearchParams({ type, query: query.trim() });
        if (type === 'vehicle' && customerId) params.set('customer_id', customerId);
        const response = await apiCall(`business/reports-v2/filter-options?${params}`, 'get', null,
          { signal: controller.signal, background: true });
        if (!canceled) setOptions(response?.data || []);
      } catch (failure) {
        if (!canceled && failure.code !== 'ERR_CANCELED') setError('Sonuçlar alınamadı. Aramayı tekrar deneyin.');
      } finally {
        if (!canceled) setLoading(false);
      }
    }, 300);
    return () => { canceled = true; clearTimeout(timer); controller.abort(); };
  }, [query, selected, type, customerId, open]);

  const choose = option => { onSelect(option); setOpen(false); setActive(-1); };
  const show = () => {
    const box = input.current.getBoundingClientRect();
    setUpward(window.innerHeight - box.bottom < 240 && box.top > 240);
    setOpen(true);
  };
  return (
    <div className="rz-lookup" ref={root}>
      <label htmlFor={id}><span>{label}</span></label>
      <div className={`rz-lookup-input${selected ? ' selected' : ''}`}>
        <i className={`fa ${type === 'customer' ? 'fa-user-o' : 'fa-car'}`} aria-hidden="true" />
        <input ref={input} id={id} type="search" value={query} maxLength={100} autoComplete="off"
          data-validation-field={type === 'customer' ? 'customer_id' : 'vehicle_id'}
          placeholder={type === 'customer' ? 'Ad, ünvan veya telefon ara' : customerId ? 'Müşterinin plakasını ara' : 'Plaka ara'}
          role="combobox" aria-autocomplete="list" aria-expanded={open && !selected}
          aria-controls={`${id}-options`} aria-activedescendant={active >= 0 ? `${id}-option-${active}` : undefined}
          onFocus={show} onChange={event => { onQueryChange(event.target.value); setOpen(true); }}
          onBlur={event => { if (!root.current.contains(event.relatedTarget)) setOpen(false); }}
          onKeyDown={event => {
            if (event.key === 'Escape') setOpen(false);
            if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && options.length) {
              event.preventDefault(); setOpen(true);
              setActive(previous => event.key === 'ArrowDown' ? Math.min(previous + 1, options.length - 1) : Math.max(previous - 1, 0));
            }
            if (event.key === 'Enter' && open && options.length) { event.preventDefault(); choose(options[active < 0 ? 0 : active]); }
          }} />
        {query && <button type="button" aria-label={`${label} filtresini temizle`}
          onMouseDown={event => event.preventDefault()} onClick={() => { onQueryChange(''); setOpen(false); }}><i className="fa fa-times" /></button>}
      </div>
      {open && !selected && (
        <div className={`rz-lookup-options${upward ? ' upward' : ''}`} id={`${id}-options`} role="listbox" aria-label={`${label} sonuçları`}>
          {loading ? <div className="rz-lookup-message">Aranıyor…</div>
            : error ? <div className="rz-lookup-message error" role="alert">{error}</div>
            : query.trim().length < 2 ? <div className="rz-lookup-message">En az 2 karakter yazın.</div>
            : options.length ? options.map((option, index) => (
              <button type="button" role="option" aria-selected={active === index} id={`${id}-option-${index}`}
                className={active === index ? 'active' : ''} key={option.value}
                onMouseDown={event => event.preventDefault()} onClick={() => choose(option)}>
                <strong>{option.label}</strong><small>{option.detail}</small>
              </button>
            )) : <div className="rz-lookup-message">Eşleşen kayıt bulunamadı.</div>}
        </div>
      )}
    </div>
  );
}
